import type { CohortEventRecord } from "../auth/api-client";
import { parseApiInstant } from "../datetime/parseApiInstant";
import { cohortEventTypeLabel, formatCohortEventMessage } from "./cohort-event-icons";

function csvEscape(value: string): string {
  if (/[",\n\r]/.test(value)) return `"${value.replaceAll('"', '""')}"`;
  return value;
}

function csvRow(values: string[]): string {
  return values.map(csvEscape).join(",");
}

function downloadCsv(filename: string, rows: string[]): void {
  const body = `\uFEFF${rows.join("\r\n")}\r\n`;
  const blob = new Blob([body], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

function occurredAtIso(raw: string): string {
  const instant = parseApiInstant(raw);
  return instant ? instant.toISOString() : raw;
}

export function exportCohortActivityCsv(args: {
  events: readonly CohortEventRecord[];
  showCohortInMessage: boolean;
  filenameStem?: string;
}): void {
  const header = [
    "occurred_at",
    "event_type",
    "cohort",
    "student_email",
    "lesson_title",
    "detail",
    "description",
  ];
  const rows: string[] = [csvRow(header)];

  for (const event of args.events) {
    rows.push(
      csvRow([
        occurredAtIso(event.occurredAt),
        cohortEventTypeLabel(event.eventType),
        event.cohortLabel,
        event.studentEmail ?? "",
        event.lessonTitle ?? "",
        event.detail ?? "",
        formatCohortEventMessage(event, args.showCohortInMessage),
      ])
    );
  }

  const stem = args.filenameStem?.trim() || "activity";
  const stamp = new Date().toISOString().slice(0, 10);
  downloadCsv(`${stem}-${stamp}.csv`, rows);
}
